import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../user-redux/selector";
import { appSelector } from "../redux/selector";

import Template1 from "./Templates/Template1";
import Template2 from "./Templates/Template2";
import Template3 from "./Templates/Template3";
import { Check, LayoutTemplate, Palette } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ResumeContext from "./Resumecontext";
import {
  jsResumeFullDetailsAction,
  ResumeProjectsData,
  setCurrentSection,
  updateProjectsAction,
} from "./ResumeBuilderActions/actions";
import axios from "axios";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import Key from "../../clientVariables.json";
import { toast } from "react-toastify";
import { resumeBuilderSelector } from "./ResumeBuilderActions/selector";
import { useNavigate } from "react-router";
import { openAI } from "../common/OpenAIComponent";

export default function TemplateView({
  selectedSummaries,
  addedSkills,
  responsibilities,
}) {
  const dispatch = useDispatch();
  const pdfExportComponent = useRef(null);
  const container = useRef(null);
  const navigate = useNavigate();
  const contextObject = useContext(ResumeContext);
  const { resumeFullDetails, resumeProjectsData, currentSection } = useSelector(
    resumeBuilderSelector
  );
  //console.log("resumeFullDetails", resumeFullDetails);
  const { user } = useSelector(userSelector);
  const { selectedCandidate, selectedJob } = useSelector(appSelector);
  const { resumedetails = {}, educationdetails = [], certificatedetails = [] } = resumeFullDetails || {};
  const [ipAddress, setIpAddress] = useState("");
  //console.log(resumeFullDetails);
  const [educationData, setEducationData] = useState(educationdetails || []);
  const [isExportingPDF, setIsExportingPDF] = useState(false);

  const [bgColor, setBgColor] = useState("#3B82F6");
  const [showPicker, setShowPicker] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(
    resumedetails?.template_number || 0
  );
  const [relatedTitles, setRelatedTitles] = useState([]);
  const pickerRef = useRef(null);

  const colorOptions = [
    { name: "Royal Blue", color: "#2563EB" },
    { name: "Sky Blue", color: "#38BDF8" },
    { name: "Violet", color: "#7C3AED" },
    { name: "Lavender", color: "#A78BFA" },
    { name: "Emerald", color: "#10B981" },
    { name: "Sage", color: "#84CC16" },
    { name: "Brick Red", color: "#DC2626" },
    { name: "Amber", color: "#F59E0B" },
    { name: "Teal", color: "#14B8A6" },
    { name: "Rose", color: "#F43F5E" },
    { name: "Charcoal", color: "#374151" },
    { name: "Slate Gray", color: "#64748B" },
  ];

  const templateOptions = [
    { id: 0, name: "Template 1" },
    { id: 2, name: "Template 2" },
    { id: 3, name: "Template 3" },
  ];

  const allowedadmincompanies = [4854, 45721, 483370, 446766];

  const isAdminCompany = allowedadmincompanies.includes(
    Number(user?.companyid)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  const handleColorSelect = (color) => {
    setBgColor(color);
    setShowPicker(false);
  };

  const togglePicker = () => setShowPicker(!showPicker);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const Url = window.location.pathname;
        const currentUrl = Url?.split("/");
        const currentResumeId = currentUrl[3]?.split("_");
        const value = currentResumeId[1];
        const data = {
          resume_id: value,
          user_id: user?.id,
          session_token: user.session_token,
        };
        const response = await dispatch(jsResumeFullDetailsAction(data));
        //console.log(response);
        //console.log(response?.data?.data?.resumedetails);
        const resumeDetails = response?.data?.data?.resumedetails;
        const projectDetails = response?.data?.data?.projectdetails;
        await dispatch(ResumeProjectsData(projectDetails));
        await dispatch(updateProjectsAction(projectDetails));
        if (contextObject.summary?.replace(/<[^>]+>/g, "").trim() === "") {
          contextObject.updateSummary(
            response?.data?.data?.resumedetails?.summary
          );
        }
        contextObject.updateJobTitle(
          response?.data?.data?.resumedetails?.application_title
        );
        contextObject.updateExperience(
          response?.data?.data?.resumedetails?.total_experience
        );
        // contextObject.updateAISkills(response?.data?.data?.resumedetails?.ai_skills?.split(","))
        //console.log(contextObject.jobTitle);
        //console.log(contextObject.experience);
        //console.log(resumeFullDetails?.resumedetails);
      } catch (error) {
        console.error("Error fetching data or updating contextObject:", error);
      }
    };

    fetchData();
  }, []);

  const paperstyles = {
    width: "100%",
    height: "90vh",
    overflow: "auto",
    //  boxShadow: `0 0 1px 1px ${bgColor}`,
  };

  const dataURLtoFile = (dataUrl, filename) => {
    let arr = dataUrl.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };


  useEffect(() => {
    if (!educationdetails || !Array.isArray(educationdetails)) return;

    const formattedArray = educationdetails.map(e => ({
      value: `${e.degree} in ${e.university}`,
    }));

    setEducationData(formattedArray);

    if (contextObject.finishOne === true) {
      handleSave();
    }

    //console.log(contextObject.finishOne);
  }, [contextObject.finishOne, educationdetails]);


  const handleDownload = () => {
    let element = container.current;
    // element.style.width = '100%';
    // element.style.maxWidth = '800px';

    // Set PDF export mode to remove highlighting
    setIsExportingPDF(true);

    // Use setTimeout to ensure state update is processed before drawing
    setTimeout(() => {
      drawDOM(element, {
        paperSize: "A4",
        margin: 38,
        scale: 1,
        // forcePageBreak: ".page-break",
        // containerStyle: {
        //   width: '100%',
        //   display: 'flex',
        //   justifyContent: 'space-between',
        // }
      })
        .then((group) => {
          element.style.maxWidth = "900px";
          return exportPDF(group);
        })
        .then((dataUri) => {
          //console.log(dataUri);
          saveAs(dataUri, "resume_" + contextObject.name);
          var file = dataURLtoFile(dataUri, contextObject.name + ".pdf");
          //console.log(file);

          // Reset PDF export mode
          setIsExportingPDF(false);
        })
        .catch((error) => {
          console.error("Error during the PDF generation", error);
          // Reset PDF export mode on error
          setIsExportingPDF(false);
        });
    }, 100);
  };

  const handleSave = async () => {
    const isAdminCompany = allowedadmincompanies.includes(
      Number(user?.companyid)
    );

    const candidateId = isAdminCompany
      ? (selectedCandidate?.candidate_id || selectedCandidate?.id)
      : user?.candidate_id;

    console.log("selected Candidate", selectedCandidate);

    if (!candidateId) {
      toast.error("Candidate ID not found. Please try again.");
      console.error("candidateId is undefined", { selectedCandidate, user });
      return;
    }

    const ProjectsData = resumeProjectsData.map((project) => ({
      id: currentSection?.id,
      projectTitle: project.pro_title,
      country: project.pro_country,
      countryname: project.countryName,
      state: project.pro_state,
      statename: project.statename,
      city: project.pro_city,
      cityname: project.cityname,
      title: project.pro_role,
      responsibilities: project.pro_responsibilities,
      description: project.pro_description,
      startdate: project.pro_startdate,
      enddate: project.pro_enddate,
      role: project.pro_role,
      company: project.pro_client,
      checked: project.is_current_project === 1,
      is_current_project: project.is_current_project,
      pro_client_domain: project.pro_client_domain,
      pro_technologies: project.pro_technologies,
      pro_address_full: project.pro_address_full,
      pro_zipcode: project.pro_zipcode,
      pro_till_date: project.pro_till_date,
      pro_createdate: project.pro_createdate,
      pro_modified: project.pro_modified,
      pro_createdtime: project.pro_createdtime,
      pro_country_new: project.pro_country_new,
      pro_state_new: project.pro_state_new,
      pro_city_new: project.pro_city_new,
    }));

    //console.log("resumeProjectsData", resumeProjectsData);
    if (user !== null) {
      let element = container.current;

      try {
        // Set PDF export mode to remove highlighting
        setIsExportingPDF(true);

        // Use setTimeout to ensure state update is processed before drawing
        setTimeout(async () => {
          try {
            const group = await drawDOM(element, {
              paperSize: "A4",
              margin: 38,
              scale: 0.8,
            });

            let dataUri;
            try {
              dataUri = await exportPDF(group);
            } catch (exportError) {
              console.error("Error during the first PDF export", exportError);
              toast.error("Failed to generate the PDF. Please try again.");
              setIsExportingPDF(false);
              return;
            }
            const file = dataURLtoFile(dataUri, resumedetails?.full_name + ".pdf");
            const formData = new FormData();
            formData.append("resume", file);

            const getTitleSuggestions = () => {
              return new Promise((resolve) => {
                const title =
                  selectedJob?.jobtitle &&
                    selectedJob.jobtitle !== "null" &&
                    selectedJob.jobtitle !== "undefined"
                    ? selectedJob.jobtitle
                    : contextObject.jobTitle;

                if (!title) {
                  console.warn("Please Enter Title");
                  resolve([]);
                  return;
                }

                const msg = `Extract exactly 10 related job roles for the following job title: "${title}".
Rules:
- Return ONLY a comma-separated list of job role titles inside the JSON
- Each role must be 2+ words (no single-word roles)
- Do NOT include skills, technologies, tools, or frameworks (e.g. no "Java", "AWS", "Python")
- Do NOT repeat the same role in different forms
- Only include roles closely related to the job title's industry and responsibilities
- Maximum 10 roles, no more

Return ONLY valid JSON: { "related_titles": ["Role 1", "Role 2", ...] }`;

                openAI(msg, (error, results) => {
                  if (error) {
                    console.error("Error fetching titles:", error);
                    resolve([]);
                  } else {
                    const titles = results?.data?.related_titles || results?.related_titles || [];
                    setRelatedTitles(titles);
                    resolve(titles);
                  }
                });
              });
            };

            const titles = await getTitleSuggestions();

            console.log("titles", titles);

            if (titles.length > 0) {
              console.log("resumedetails", resumedetails);
              toast.success("Resume parsed successful!");
              const resumePayload = {
                candidate_id: candidateId,
                ai_skills:
                  [resumedetails?.ai_skills, contextObject?.aiSkills]
                    .filter(Boolean)
                    .join(", ")
                    .split(",") || [],
                user_id: user?.id,
                application_title: contextObject.jobTitle,
                full_name: resumedetails?.full_name,
                first_name: resumedetails?.first_name,
                last_name: resumedetails?.last_name,
                home_phone: resumedetails?.home_phone || "",
                email_address: resumedetails?.email || "",
                total_experience: contextObject.experience,
                location_state: contextObject.location_state || "",
                location_city: contextObject.location_city || "",
                summary: contextObject.summary || "",
                skills_titles:
                  [resumedetails?.ai_skills, contextObject?.aiSkills]
                    .filter(Boolean)
                    .join(", ")
                    .split(",") || "",
                source: "fromBenchsales",
                uploaded_uid: user?.id,
                linkedin_url: resumedetails?.linkedin_url || "",
                filename: resumedetails?.filename,
                projects_data: ProjectsData || [],
                educations_data: educationdetails || [],
                certificates_data: certificatedetails?.map(c => c.cer_name) || [],
                solr_search_string: titles,
              };
              // Second API call to `bench_addFullResume`
              const resumeResponse = await axios.post(
                `${Key.domain}/candidate/bench_addFullResume`,
                resumePayload
              );

              const resumeId = resumeResponse?.data?.data?.insertId;

              // Additional file save logic
              try {
                const newGroup = await drawDOM(element, {
                  paperSize: "A4",
                  margin: 38,
                  scale: 0.8,
                });

                const newDataUri = await exportPDF(newGroup);
                saveAs(newDataUri, "resume_" + resumedetails?.full_name);

                const newFile = dataURLtoFile(
                  newDataUri,
                  resumedetails?.full_name + ".pdf"
                );

                // Prepare data for file upload
                const uploadData = new FormData();
                uploadData.append("file", newFile);
                uploadData.append("userid", user?.id);
                uploadData.append("candidateid", candidateId);
                uploadData.append("filename", newFile.name);
                uploadData.append("file_size", newFile.size);
                uploadData.append("file_type", newFile.type);
                uploadData.append("attachment_type", "Candidate_res_attachment");
                uploadData.append("attachment_name", newFile.name);
                uploadData.append("file_created", newFile.lastModifiedDate);
                uploadData.append("resumeid", resumeId);
                uploadData.append("role", contextObject.jobTitle);

                await axios.post(
                  `${Key.domain}/candidate/upload_document`,
                  uploadData
                );
                //console.log("All APIs called successfully");
                toast.success("Resume uploaded successfully!");
                // dispatch(openInterestedAction())
                if (isAdminCompany) {
                  contextObject.updateFinish(false);
                  contextObject.updateJobTitle?.("");
                  contextObject.updateEmail?.("");
                  contextObject.updatePhone?.("");
                  contextObject.updateExperience?.("");
                  contextObject.updateFinishOne?.(false);
                  contextObject.updateSummary?.("");
                  contextObject.updateAISkills?.([]);
                } else {
                  contextObject.updateFinish(true);
                }
                dispatch(
                  setCurrentSection(
                    currentSection?.section,
                    currentSection?.id,
                    true
                  )
                );
                if (isAdminCompany) {
                  navigate("/my-candidates");
                } else {
                  navigate("/candidates-list");
                }
                contextObject.updateFinishOne(false);

                // Reset PDF export mode
                setIsExportingPDF(false);
              } catch (finalExportError) {
                console.error(
                  "Error during the final PDF export",
                  finalExportError
                );
                toast.error("Failed to save the PDF.");
                setIsExportingPDF(false);
              }
            }
          } catch (error) {
            console.error("Error occurred:", error);
            toast.error("An error occurred. Please try again.");
            setIsExportingPDF(false);
          }
        }, 100);
      } catch (error) {
        console.error("Error occurred:", error);
        toast.error("An error occurred. Please try again.");
        setIsExportingPDF(false);
      }
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Box>
          <Paper
            elevation={2}
            sx={{
              ...paperstyles,
            }}
          >
            <PDFExport
              ref={pdfExportComponent}
              scale={0.8}
              fileName={"resume_" + "sudha"}
              paperSize="A4"
              margin="1cm"
            >
              <Grid
                container
                spacing={0}
                sx={{
                  background:
                    "radial-gradient(circle, #fff, aliceblue ,#fff,aliceblue,#fff)",
                  boxSizing: "border-box",
                }}
              >
                {/* 🛠️ TOP TOOLBAR: Separated from the resume document */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    bgcolor: "#fff",
                    borderBottom: "1px solid #e0e0e0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    py: 1.5,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 700, color: "#2c3e50" }}>
                    Resume Preview
                  </Typography>

                  <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                    {/* 🎨 Accent Picker */}
                    <Box sx={{ position: "relative" }}>
                      <Tooltip title="Accent Color" placement="bottom" arrow>
                        <IconButton
                          onClick={togglePicker}
                          sx={{
                            color: bgColor,
                            border: `1.5px solid ${bgColor}40`,
                            p: 1,
                            "&:hover": { bgcolor: `${bgColor}08` }
                          }}
                        >
                          <Palette size={20} />
                        </IconButton>
                      </Tooltip>

                      {showPicker && (
                        <Box
                          ref={pickerRef}
                          sx={{
                            position: "absolute",
                            top: "50px",
                            right: 0,
                            zIndex: 2000,
                            boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.12)",
                            bgcolor: "#fff",
                            borderRadius: "12px",
                            p: 2,
                            width: 220,
                            border: "1px solid #e0e0e0"
                          }}
                        >
                          <Typography sx={{ fontSize: "0.75rem", fontWeight: 700, color: "#94a3b8", mb: 1.5, textTransform: "uppercase", letterSpacing: 0.5 }}>Select Accent Color</Typography>
                          <Grid container spacing={1}>
                            {colorOptions.map((color) => (
                              <Grid item xs={3} key={color.name}>
                                <Box
                                  onClick={() => handleColorSelect(color.color)}
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: "8px",
                                    bgcolor: color.color,
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    "&:hover": { transform: "scale(1.1)", boxShadow: "0 4px 8px rgba(0,0,0,0.15)" },
                                    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                                    border: "2px solid transparent",
                                  }}
                                >
                                  {bgColor === color.color && (
                                    <Check size={18} strokeWidth={3} color="#fff" />
                                  )}
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                    </Box>

                    {/* 📄 Template Button */}
                    <Tooltip title="Switch Template" placement="bottom" arrow>
                      <IconButton
                        onClick={() => setShowTemplateModal(true)}
                        sx={{
                          color: "#64748b",
                          border: "1.5px solid #e2e8f0",
                          p: 1,
                          "&:hover": { bgcolor: "#f8fafc", color: "#334155" }
                        }}
                      >
                        <LayoutTemplate size={20} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>

                {/* 🧱 Template Selection Modal */}
                <Dialog
                  open={showTemplateModal}
                  onClose={() => setShowTemplateModal(false)}
                  fullWidth
                  maxWidth="md"
                  sx={{
                    "& .MuiDialog-paper": {
                      borderRadius: "16px",
                      p: 2,
                    },
                  }}
                >
                  <IconButton
                    onClick={() => setShowTemplateModal(false)}
                    sx={{ position: "absolute", top: 10, right: 10 }}
                  >
                    <CloseIcon />
                  </IconButton>

                  <Typography
                    variant="h6"
                    align="center"
                    sx={{ mb: 3, mt: 2, fontWeight: 600 }}
                  >
                    Select Your Resume Template
                  </Typography>

                  <DialogContent>
                    <Grid container spacing={3} justifyContent="center">
                      {templateOptions.map((template) => (
                        <Grid item xs={12} sm={6} md={4} key={template.id}>
                          <Box
                            onClick={() => {
                              setSelectedTemplate(template.id);
                              setShowTemplateModal(false);
                            }}
                            sx={{
                              cursor: "pointer",
                              borderRadius: "12px",
                              overflow: "hidden",
                              border:
                                selectedTemplate === template.id
                                  ? `3px solid ${bgColor}`
                                  : "1px solid #e0e0e0",
                              transition: "all 0.3s ease",
                              p: 2,
                              textAlign: "center",
                              "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
                              },
                            }}
                          >
                            <Box sx={{
                              height: 180,
                              bgcolor: "#f5f5f5",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "center",
                              borderRadius: "8px",
                              mb: 1,
                              overflow: "hidden",
                              position: "relative",
                              border: "1px solid #eee"
                            }}>
                              <Box sx={{
                                width: "1000px", // Width of a typical A4-style container
                                transformOrigin: "top center",
                                transform: "scale(0.18)", // Scale down to fit the card
                                pointerEvents: "none", // Prevent interaction
                                position: "absolute",
                                top: 0
                              }}>
                                {template.id === 0 ? (
                                  <Template1
                                    selectedSummaries={selectedSummaries}
                                    addedSkills={addedSkills}
                                    responsibilities={responsibilities}
                                    forPDF={true} // Use PDF mode to hide edit icons/highlights if desired
                                    accentColor={bgColor}
                                  />
                                ) : template.id === 2 ? (
                                  <Template2
                                    accentColor={bgColor}
                                    forPDF={true}
                                    addedSkills={addedSkills}
                                  />
                                ) : (
                                  <Template3
                                    accentColor={bgColor}
                                    forPDF={true}
                                    addedSkills={addedSkills}
                                  />
                                )}
                              </Box>
                            </Box>
                            <Typography
                              fontWeight={600}
                              color={selectedTemplate === template.id ? bgColor : "inherit"}
                            >
                              {template.name}
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </DialogContent>
                </Dialog>

                {/* 📄 DOCUMENT CANVAS: The area where the resume "sits" */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    flexGrow: 1,
                    bgcolor: "#f1f5f9", // Soft light gray canvas
                    p: 2,
                    display: "flex",
                    justifyContent: "center",
                    minHeight: "100%",
                  }}
                >
                  <Box
                    ref={container}
                    sx={{
                      width: "100%",
                      maxWidth: "850px", // Reduced slightly to prevent clipping
                      bgcolor: "#fff",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.1)", // Float effect
                      borderRadius: "4px",
                      overflow: "visible" // Changed from hidden to prevent clipping
                    }}
                  >
                    {selectedTemplate === 0 ? (
                      <Template1
                        selectedSummaries={selectedSummaries}
                        addedSkills={addedSkills}
                        responsibilities={responsibilities}
                        forPDF={isExportingPDF}
                        accentColor={bgColor}
                      />
                    ) : selectedTemplate === 2 ? (
                      <Template2
                        accentColor={bgColor}
                        forPDF={isExportingPDF}
                        addedSkills={addedSkills}
                      />
                    ) : selectedTemplate === 3 ? (
                      <Template3
                        accentColor={bgColor}
                        forPDF={isExportingPDF}
                        addedSkills={addedSkills}
                      />
                    ) : (
                      <Template1
                        selectedSummaries={selectedSummaries}
                        addedSkills={addedSkills}
                        responsibilities={responsibilities}
                        forPDF={isExportingPDF}
                        accentColor={bgColor}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
            </PDFExport>
          </Paper>
        </Box>
      </Grid>
    </>
  );
}
